'use strict';

var React = require('react');

var SvgLabelPrinterMajor = function SvgLabelPrinterMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 2.5a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5v3.5h1.5a1.5 1.5 0 0 1 1.5 1.5v10a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-10a1.5 1.5 0 0 1 1.5-1.5h1.5v-3.5zm2 9.5h8v-9h-8v9zm-2 3a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1zm11 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
  }));
};

exports.SvgLabelPrinterMajor = SvgLabelPrinterMajor;
